import React, { useState, useId } from 'react';
import { Accordion, Column, Row, Icon, Margin } from '@upgrade/react-components';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { toHtmlSanitize } from '../../../utils/remark-html';

import { ConstrainedContent } from '../styles';
import { StyledAnswer, StyledPanel, FAQContainer, HitArea, Dd } from './styles';
import Fluid from '../../Fluid';
import { Heading, Text } from '../TypographyPublicSite';

/**
 * @deprecated This component as is should not be used, given it mixes part of
 * the behavior of the Accordion available as part of the foundation components.
 */
export const FAQItem = ({ answer, question, headingTag, isLast }) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const answerId = useId();

  return (
    <FAQContainer itemScope itemProp="mainEntity" itemType="https://schema.org/Question" $isLast={isLast}>
      <dt>
        <HitArea
          aria-controls={answerId}
          aria-expanded={showAnswer}
          onClick={() => setShowAnswer(prevShowAnswer => !prevShowAnswer)}
        >
          <Heading as={headingTag} size="xs" itemProp="name" marginBottom="none">
            {question}
          </Heading>
          <Icon color="content" icon={showAnswer ? mdiChevronUp : mdiChevronDown} size="2.5rem" />
        </HitArea>
      </dt>
      <Dd itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
        <Text
          hidden={!showAnswer}
          itemProp="text"
          color="contentWeak"
          id={answerId}
          size="md"
          dangerouslySetInnerHTML={{ __html: toHtmlSanitize(answer) }}
        />
      </Dd>
    </FAQContainer>
  );
};

export const FAQItemAccordionPanel = ({ answer, question, headingTag, ...panelProps }) => {
  const header = (
    <Heading as={headingTag} size="xs" itemProp="name" marginBottom="none">
      {question}
    </Heading>
  );

  return (
    <StyledPanel
      header={header}
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
      contentPadding="none"
      {...panelProps}
    >
      <StyledAnswer itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
        <Text
          as="div"
          itemProp="text"
          color="contentWeak"
          size="md"
          dangerouslySetInnerHTML={{ __html: toHtmlSanitize(answer) }}
        />
      </StyledAnswer>
    </StyledPanel>
  );
};

export default ({ faq: { title = 'FAQ', subtitle, items = [], showFAQ } }) => {
  if (!showFAQ) return null;

  return (
    <Fluid itemScope itemType="https://schema.org/FAQPage">
      <Margin top={{ xs: 'md', sm: '3xl' }} bottom="md">
        <ConstrainedContent>
          <Row xsHorizontalAlign="center">
            <Column xs={12}>
              <Heading as="h2" size="sm">
                {title}
              </Heading>
              {subtitle && (
                <Text marginBottom="lg" color="contentWeak" size="md">
                  {subtitle}
                </Text>
              )}
            </Column>
          </Row>
          <Margin top="sm">
            <Accordion exclusive={false}>
              {items.map(({ question, answer }) => (
                <FAQItemAccordionPanel key={question} question={question} answer={answer} headingTag="h3" />
              ))}
            </Accordion>
          </Margin>
        </ConstrainedContent>
      </Margin>
    </Fluid>
  );
};
